import { render } from "./ModalAlert.vue?vue&type=template&id=36f2146a&scoped=true"
import script from "./ModalAlert.vue?vue&type=script&lang=js"
export * from "./ModalAlert.vue?vue&type=script&lang=js"

import "./ModalAlert.vue?vue&type=style&index=0&id=36f2146a&rel=scss&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36f2146a"]])

export default __exports__